import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { LeagueData } from "src/mockup/LoginData";

// This function is specifically for ESPN, which has a different data structure after login.
export const getUserLeaguesEspn = async (
  espnUserData: {
    integration_name: string;
    token: string;
    user_id?: string;
    user_email?: string;
    swid?: string;
    s2?: string;
  },
  accessAuthToken: string,
  pocToken: string,
  signal?: AbortSignal
): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/fantasy_leagues/get_user_leagues`;

    // The payload for the backend needs the token from the login step to be mapped to `leagueToken`.
    const data: LeagueData = {
      integration_name: espnUserData.integration_name,
      user_id: espnUserData.user_email || "",
      user_email: espnUserData.user_email,
      leagueToken: espnUserData.token, // This is the key change
      swid: espnUserData.swid,
      espn_s2: espnUserData.s2,
      sport: "NFL",
      // year: "2025",
      pocToken: pocToken,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(data),
      signal: signal,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Request failed. Please try again");
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Something went wrong when getting ESPN teams data", error);
    showErrorToast("Something went wrong when getting ESPN teams data");
    throw error;
  }
};